import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';

@Component({
  selector: 'app-inactive-message',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './inactive-message.component.html',
  styleUrl: './inactive-message.component.css',
})
export class InactiveMessageComponent {
  @Output() buttonClick = new EventEmitter<Event>();

  onClick(event: Event) {
    this.buttonClick.emit(event);
  }
}
